import { FC } from 'react'

import { Backdrop } from '~/components/Backdrop'
import { TextButton } from '~/components/TextButton'

import theme from '~/theme'

import { translate } from '~/utils/translate'

import * as Styled from './styles'
import { IUnavailableToWearBackdropProps } from './types'

export const UnavailableToWearBackdrop: FC<IUnavailableToWearBackdropProps> = ({
  visible,
  thumbnail,
  identifier,
  handleNavigate,
  handleChangeProduct,
}) => {
  return (
    <Backdrop testID="unavailable-to-wear-backdrop" visible={visible}>
      <Styled.Content>
        <Styled.Thumbnail data-testid="thumbnail" src={thumbnail} />
        <Styled.Title>{translate('BACKDROP_UNAVAILABLE_TO_WEAR_TITLE')}</Styled.Title>
        <Styled.Description>{translate('BACKDROP_UNAVAILABLE_TO_WEAR_DESCRIPTION')}</Styled.Description>
        <Styled.Actions>
          <TextButton testID="button-change-product" onClick={() => handleChangeProduct()}>
            {translate('BACKDROP_UNAVAILABLE_TO_WEAR_CHANGE_PRODUCT_BUTTON')}
          </TextButton>
          <TextButton
            testID="button-navigate"
            onClick={() => handleNavigate({ identifier })}
            background={theme.colors.neutral.black100}
            textColor={theme.colors.primary}
          >
            {translate('BACKDROP_UNAVAILABLE_TO_WEAR_VIEW_SIZE_TABLE')}
          </TextButton>
        </Styled.Actions>
      </Styled.Content>
    </Backdrop>
  )
}
